<template>
    <b-container class="bv-example-row">
        <alert :message="message" />

        <b-alert v-if="$route.params.message" :show="5" dismissible>
            {{ $route.params.message }}
        </b-alert>

        <b-row>
            <b-col md="12">
                <h3 v-if="this.prototype">Prototype - {{ this.prototype.name }}

                    <a :href="this.$gitlabURL + this.prototype.name" target="_blank">Go to gitlab</a>
                    <i class="far fa-clone px-2 " @click="copy" id="tooltip-target-1"></i>

                    <b-tooltip target="tooltip-target-1" triggers="hover">
                        {{ this.copyMessage }}
                    </b-tooltip>
                </h3>
            </b-col>
        </b-row>

        <b-row align-v="center" class="px-2 mb-3" v-if="this.prototype">
            <b-col md="2">
                Gitlab resource file:
            </b-col>

            <b-col>
                <input type="file" @change="uploadResourceFile" ref="res_file" accept="application/zip">
                <b-button class="mx-2" variant="primary" :disabled="!RepositoryResourceFile || UploadingFile"
                    @click="upload_gitlab_resource()">
                    {{ UploadingFile ? "Upload..." : "Upload resource" }}</b-button>
            </b-col>
        </b-row>

        <b-form ref="detailsForm" v-if="this.prototype" class="px-2" @submit="onSubmit">

            <b-row class="mb-3">
                <b-col md="2">
                    Created at
                </b-col>
                <b-col md="4">
                    {{ new Date(this.prototype.created_at).toLocaleString() }}
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col md="2">
                    Updated at
                </b-col>
                <b-col md="9" v-if="this.prototype.updated_at">
                    {{ new Date(this.prototype.updated_at).toLocaleString() }}
                </b-col>
            </b-row>

            <b-form-group label-cols-lg="2" label="Is instantiatable" label-for="input-public">
                <b-form-checkbox class="col-form-label" id="input-public" v-model="prototype.is_instantiatable" />
            </b-form-group>

            <b-form-group label-cols-lg="2" label="Prototype version" label-for="input-prototype-version">
                <b-form-input type="number" placeholder="" id="input-prototype-version" v-model="prototype.version" />
            </b-form-group>

            <b-form-group label-cols-lg="2" label="Asset pack version" label-for="input-asset-pack-version">
                <b-form-input type="number" placeholder="" id="input-asset-pack-version"
                    v-model="prototype.asset_pack_version" />
            </b-form-group>

            <b-button type="submit" variant="primary">Submit</b-button>

            <b-button variant="warning" class="mx-2" @click="runPipeline">Run pipeline</b-button>

            <b-button @click="openPipelineModalAndLogs">Gitlab job status</b-button>

            <b-button v-b-modal.delete_prototype_modal variant="danger" class="float-right">Delete prototype</b-button>
        </b-form>

        <div v-if="this.prototype">
            <h4>Prototype versions</h4>
            <b-container>
                <b-row>
                    <b-col>
                        <b-button variant="success" @click="newSpacePrototypeVersion()" class="mb-3">
                            New version
                        </b-button>
                    </b-col>

                    <b-col>
                        <div>
                            Resource file:
                            <input type="file" @change="uploadFile" ref="prototype_file">
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-table id="my-table-users" v-if="this.prototype" :fields="prototype_version_fields"
                :items="prototype.prototype_versions" :per-page="perPage" :current-page="currentPageVersion" small
                striped>
                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="remove_prototype_version(data.item.version)" />
                    <button :disabled="!PrototypeResourceFile || UploadingFile"
                        @click="upload_resource(data.item.version)">
                        {{ UploadingFile ? "Upload..." : "Upload resource" }}</button>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-if="this.prototype.updated_at" v-slot:cell(updated_at)="data">
                    <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(resource_zip)="data">
                    <a :href="data.item.presigned_url_zip">{{ data.value }}</a>
                </template>
                <template v-slot:cell(resource_tar)="data">
                    <a :href="data.item.presigned_url_tar">{{ data.value }}</a>
                </template>
            </b-table>
            <b-pagination v-model="currentPageVersion" :total-rows="prototype.prototype_versions.length"
                :per-page="perPage" align="fill" size="sm" class="my-0" />
        </div>

        <div v-if="this.prototype">
            <h4>Project prototypes</h4>
            <b-container>
                <b-row>
                    <b-col>
                        <b-button variant="success" @click="newProjectPrototype()" class="mb-3">
                            New project prototype
                        </b-button>
                    </b-col>

                    <b-col>
                        <div>
                            JSON file:
                            <input type="file" @change="uploadJSONFile" ref="json_file">
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-table id="my-table-users" v-if="this.prototype" :fields="project_prototype_fields"
                :items="prototype.project_prototypes" :per-page="perPage" small striped>

                <template v-slot:cell(name)="data">
                    <b-link @click="download_JSON(data.item.uuid)">{{ data.value }}</b-link>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="removeProjectPrototype(data.item.uuid)" />
                    <button :disabled="!JSONResourceFile || UploadingFile"
                        @click="upload_json_resource(data.item.uuid)">
                        {{ UploadingFile ? "Upload..." : "Upload resource" }}</button>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-if="this.prototype.updated_at" v-slot:cell(updated_at)="data">
                    <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                </template>
            </b-table>
        </div>

        <div v-if="this.prototype">
            <h4>Asset pack versions</h4>
            <b-container>
                <b-row>
                    <b-col>
                        <b-button variant="success" @click="newAssetPackVersion()" class="mb-3">
                            Upload new asset pack
                        </b-button>
                    </b-col>

                    <b-col>
                        <div>
                            <input type="file" @change="uploadAssetFile" ref="asset_pack_file" accept="application/zip"
                                style="display: none;">
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-table id="my-table-users" v-if="this.prototype" :fields="asset_pack_version_fields"
                :items="prototype.asset_pack_versions" :per-page="perPage" small striped>
                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="remove_asset_pack_version(data.item.version)" />
                </template>
                <template v-slot:cell(asset_pack_zip)="data">
                    <a :href="data.item.presigned_url_zip">{{ data.value }}</a>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(updated_at)="data">
                    <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                </template>
            </b-table>
        </div>

        <div v-if="this.prototype">
            <h4>Spaces</h4>
            <b-container>
                <b-button
                    :disabled="!this.prototype.prototype_versions || !this.prototype.version in this.prototypeIndexArray"
                    class="ml-1 mb-3" variant="success" v-b-modal.modalPopover>New space</b-button>
            </b-container>

            <b-table id="my-table-users" v-if="this.prototype" :items="prototype.spaces"
                :fields="prototype_space_fields" :per-page="perPage" :current-page="currentPageSpace" small striped>
                <template v-slot:cell(name)="data">
                    <router-link :to="'/space/' + data.item.uuid">{{ data.value }}</router-link>
                </template>
                <template v-slot:cell(is_public)="data">
                    <label v-if="data.value">&#9989;</label>
                    <label v-else>&#10060;</label>
                </template>
                <template v-slot:cell(is_sandbox)="data">
                    <label v-if="data.value">&#9989;</label>
                    <label v-else>&#10060;</label>
                </template>
                <template v-slot:cell(unlisted)="data">
                    <label v-if="data.value">&#9989;</label>
                    <label v-else>&#10060;</label>
                </template>
                <template v-slot:cell(updated_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="deleteSpace(data.item)" />
                </template>
            </b-table>
            <b-pagination v-model="currentPageSpace" :total-rows="prototype.spaces.length" :per-page="perPage"
                align="fill" size="sm" class="my-0" />
        </div>

        <div v-if="this.prototype">
            <h4>OTF Assets</h4>
            <b-container>
                <b-row>
                    <b-col>
                        <b-button :disabled="!otfAsset" variant="success" @click="submitNewOTFAsset()" class="mb-3">
                            Add OTF Asset
                        </b-button>
                    </b-col>
                    <b-col cols="8">
                        <ejs-dropdownlist id='dropdownlist' placeholder='OTF Assets' :allowFiltering='true'
                            :dataSource='list_of_otf_assets' :fields='otf_asset_select_fields' v-model='otfAsset'>
                        </ejs-dropdownlist>
                    </b-col>
                </b-row>
            </b-container>

            <b-table id="my-table-users" v-if="this.prototype" :items="prototype.otf_assets" :fields="otf_asset_fields"
                :per-page="perPage" small striped>
                <template v-slot:cell(name)="data">
                    <router-link :to="'/otf_asset/' + data.item.uuid">{{ data.value }}</router-link>
                </template>
                <template v-slot:cell(unlisted)="data">
                    <label v-if="data.value">&#9989;</label>
                    <label v-else>&#10060;</label>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                        @click="remove_otf_asset(data.item.uuid)" />
                </template>
            </b-table>
        </div>

        <b-modal v-model="showModal" size="lg" scrollable @hide="stopPeriodicFunction" ok-only>
            <template #modal-title>
                Gitlab job status - {{ prototype.name }}
            </template>
            <b-table id="gitlab-task-logs" v-if="this.gitlabJobTasks" :items="gitlabJobTasks"
                :fields="gitlab_task_fields" small striped hover style="cursor: pointer;">
                <template v-slot:cell(id)="data">
                    <a href="javascript:void(0)" @click="handleRowClicked(data.value)"> {{ data.value }} </a>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(finished_at)="data">
                    <span v-if="data.value">{{ new Date(data.value).toLocaleString() }}</span>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button :disabled="cancelingJob" type="button" size="sm" variant="danger"
                        v-if="['pending', 'running'].includes(data.item.status)"
                        @click="cancel_pipeline_job(data.item.id)">
                        <span class="btn-label"><b-icon-stop-fill class="lign-middle mr-2"
                                font-scale="1.5" /></span>Cancel</b-button>
                </template>
            </b-table>
        </b-modal>

        <b-modal v-model="showLogModal" size="xl" scrollable @hide="stopPeriodicFunctionLog" ok-only title="Gitlab log">
            <template #modal-title>
                Gitlab log - {{ prototype.name }} - {{ selectedJobId }}
            </template>

            <b-form-textarea id="textarea" v-model="TaskLog" max-rows="20"></b-form-textarea>
        </b-modal>

        <b-modal id="modalPopover" title="New space generation" @ok="handleOk">

            <form ref="form" @submit.stop.prevent="createNewPrototype">

                <p class="text-danger font-weight-bold text-center" v-if="error_data">{{ error_data.message }}</p>
                <b-form-group label="Name*" label-for="new-space-name" label-cols-sm="3" label-size="sm" class="mb-2">
                    <b-input-group size="sm">
                        <b-form-input id="new-space-name" v-model="spaceName" required></b-form-input>
                    </b-input-group>
                    <span class="danger" v-if="error_data && error_data.name">{{ error_data.name[0] }}</span>

                </b-form-group>

                <b-form-group label="Description*" label-for="new-space-description" label-cols-sm="3" label-size="sm">
                    <b-input-group size="sm">
                        <b-form-textarea id="new-space-description" v-model="spaceDescription"></b-form-textarea>
                    </b-input-group>
                    <span class="danger" v-if="error_data && error_data.description">{{
                        error_data.description[0]
                        }}</span>

                </b-form-group>

                <b-form-group label="Subtitle" label-for="new-space-subtitle" label-cols-sm="3" label-size="sm">
                    <b-input-group size="sm">
                        <b-form-input id="new-space-subtitle" v-model="spaceSubtitle"></b-form-input>
                    </b-input-group>
                    <span class="danger" v-if="error_data && error_data.subtitle">{{ error_data.subtitle[0] }}</span>

                </b-form-group>

                <b-form-group label="Domain" label-for="new-space-domain" label-cols-sm="3" label-size="sm">
                    <b-input-group size="sm">
                        <b-form-input id="new-space-domain" v-model="spaceDomain"></b-form-input>
                    </b-input-group>
                    <span class="danger" v-if="error_data && error_data.domain">{{ error_data.domain[0] }}</span>

                </b-form-group>

                <b-form-group label="Is public" label-for="new-space-is-public" label-cols-sm="3" label-size="sm">
                    <b-input-group size="sm">
                        <b-form-checkbox id="new-space-is-public" v-model="spaceIsPublic"></b-form-checkbox>
                    </b-input-group>

                </b-form-group>

                <b-form-group label="Is available web" label-for="new-space-is-available-web" label-cols-sm="3"
                    label-size="sm">
                    <b-input-group size="sm">
                        <b-form-checkbox id="new-space-is-available-web"
                            v-model="spaceIsAvailableWeb"></b-form-checkbox>
                    </b-input-group>

                </b-form-group>

                <b-form-group label="Is demo" label-for="new-space-is-sandbox" label-cols-sm="3" label-size="sm">
                    <b-input-group size="sm">
                        <b-form-checkbox id="new-space-is-sandbox" v-model="spaceIsSandbox"></b-form-checkbox>
                    </b-input-group>

                </b-form-group>

                <b-form-group label="Is unlisted" label-for="new-space-is-unlisted" label-cols-sm="3" label-size="sm">
                    <b-input-group size="sm">
                        <b-form-checkbox id="new-space-is-unlisted" v-model="spaceUnlisted"></b-form-checkbox>
                    </b-input-group>

                </b-form-group>
            </form>

        </b-modal>

        <b-modal id="delete_prototype_modal" title="Are you sure about the delete the prototype?" @show="resetModal"
            @hidden="resetModal" @ok="deletePrototype">
            <i>Only prototypes without spaces can be deleted!</i>

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group>
                    <b-form-checkbox id="name-input" v-model="delete_gitlab_repo" required>Delete gitlab repository
                        as well</b-form-checkbox>
                </b-form-group>
            </form>
        </b-modal>

    </b-container>
</template>


<script>
import Alert from '../components/alert.vue';
import { BIconTrashFill, BIconClipboard, BIconStopFill } from 'bootstrap-vue';

export default {
    data() {
        return {
            message: '',
            prototype: null,
            perPage: 20,
            prototype_version_fields: [
                { key: 'version', label: 'Version', class: 'text-center align-middle', sortable: true },
                { key: 'resource_tar', label: 'Resource tar', class: 'text-center align-middle' },
                { key: 'resource_zip', label: 'Resource zip', class: 'text-center align-middle' },
                { key: 'created_at', label: 'Created', class: 'text-center align-middle' },
                { key: 'updated_at', label: 'Updated', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            project_prototype_fields: [,
                { key: 'name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'created_at', label: 'Created', class: 'text-center align-middle' },
                { key: 'updated_at', label: 'Updated', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            asset_pack_version_fields: [
                { key: 'version', label: 'Version', class: 'text-center align-middle', sortable: true },
                { key: 'asset_pack_zip', label: 'Asset pack zip resource', class: 'text-center align-middle' },
                { key: 'created_at', label: 'Created', class: 'text-center align-middle' },
                { key: 'updated_at', label: 'Updated', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            prototype_space_fields: [
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'status', label: 'status', class: 'text-center align-middle' },
                { key: 'is_public', label: 'Is public', class: 'text-center align-middle' },
                { key: 'is_sandbox', label: 'Is sandbox', class: 'text-center align-middle' },
                { key: 'unlisted', label: 'Unlisted', class: 'text-center align-middle' },
                { key: 'created_at', label: 'Created at', class: 'text-center align-middle' },
                { key: 'updated_at', label: 'Updated at', class: 'text-center align-middle' },
                { key: 'actions', label: 'Action', class: 'text-center align-middle' }
            ],
            otf_asset_fields: [
                { key: 'name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'unlisted', label: 'Unlisted', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            gitlab_task_fields: [
                { key: 'id', label: 'ID', class: 'text-center align-middle', sortable: true },
                { key: 'status', label: 'Status', class: 'text-center align-middle' },
                { key: 'created_at', label: 'Started at', class: 'text-center align-middle' },
                { key: 'finished_at', label: 'Finished at', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            UploadingFile: false,
            PrototypeResourceFile: null,
            RepositoryResourceFile: null,
            JSONResourceFile: null,
            spaceName: null,
            spaceSubtitle: null,
            spaceDescription: null,
            spaceDomain: null,
            spaceIsPublic: false,
            spaceIsAvailableWeb: false,
            spaceIsSandbox: false,
            spaceUnlisted: false,
            list_of_users: [],
            error_data: null,
            delete_gitlab_repo: false,
            copyMessage: "Copy gitlab url",
            list_of_otf_assets: null,
            otfAsset: null,
            otf_asset_select_fields: { text: "name", value: "uuid" },
            currentPageVersion: 1,
            currentPageSpace: 1,
            gitlabJobTasks: null,
            showModal: false,
            intervalId: null,
            intervalIdLog: null,
            showLogModal: false,
            TaskLog: null,
            selectedJobId: null,
            cancelingJob: false,
            latestJobIsRunning: false,
            prototypeIndexArray: []
        }
    },
    components: {
        BIconTrashFill,
        BIconClipboard,
        BIconStopFill,
        alert: Alert,
    },
    methods: {
        init() {
            this.download_prototype_details();
            this.download_otf_assets();
        },
        download_prototype_details() {
            this.$http.get(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.prototype = res.data
                    this.prototype.prototype_versions.forEach((element, index) => {
                        this.prototypeIndexArray.push(element.version);
                    });
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_otf_assets() {
            this.$http.get(this.$apiURL + '/otf_assets', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.list_of_otf_assets = res.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        submitNewOTFAsset() {
            this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/otf_asset', { otf_asset_uuid: this.otfAsset }, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.otfAsset = null
                    this.message = { 'message': "OTF Asset has been set." }
                    this.download_prototype_details();
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data,
                        'type': "danger"
                    }

                });
        },
        onSubmit(event) {
            if (event) {
                event.preventDefault()
            }
            this.$http.patch(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid,
                { is_instantiatable: this.prototype.is_instantiatable, version: this.prototype.version, asset_pack_version: this.prototype.asset_pack_version },
                { headers: this.$store.getters.authHeader }
            )
                .then((response) => {
                    this.message = { 'message': "Prototype has been updated!" }
                    this.download_prototype_details();
                })
                .catch((error) => {
                    this.message = error.response.data
                    this.message.type = "danger"
                });
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.newSpace()
        },
        newSpace() {
            this.$http.post(this.$apiURL + '/space',
                {
                    prototype_uuid: this.$route.params.uuid,
                    name: this.spaceName,
                    subtitle: this.spaceSubtitle,
                    description: this.spaceDescription,
                    domain: this.spaceDomain,
                    is_public: this.spaceIsPublic,
                    is_available_web: this.spaceIsAvailableWeb,
                    is_sandbox: this.spaceIsSandbox,
                    unlisted: this.spaceUnlisted
                },
                { headers: this.$store.getters.authHeader }
            )
                .then((response) => {
                    this.message = { 'message': "New space has been created!" }
                    this.download_prototype_details();
                    this.$bvModal.hide('modalPopover')
                })
                .catch((error) => {
                    this.error_data = JSON.parse(error.request.response)
                });

        },
        newSpacePrototypeVersion() {
            this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/space_prototype_version', null, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.message = { 'message': "New prototype version has been created" }
                    this.download_prototype_details();
                })
                .catch((error) => {
                    this.message = error.request.response
                    this.message.type = "danger"
                });
        },
        newProjectPrototype() {
            let name = prompt("New project prototype name (3 character at least):");
            if (name != null && name.length > 3) {
                this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/project_prototype', { "name": name }, { headers: this.$store.getters.authHeader }
                )
                    .then((res) => {
                        this.message = { 'message': "New project prototype has been created" }
                        this.download_prototype_details();
                    })
                    .catch((error) => {
                        this.message = { "message": error.request.response }
                        this.message.type = "danger"
                    });
            }
        },
        newAssetPackVersion() {
            this.$refs.asset_pack_file.click();
        },
        remove_prototype_version(value) {
            this.$dialog
                .confirm("Are you sure about the delete of the prototype?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/version/' + value, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.message = { 'message': "Prototype version has been removed" }
                            this.download_prototype_details();
                        })
                        .catch((error) => {
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        },
        remove_asset_pack_version(value) {
            this.$dialog
                .confirm("Are you sure about the delete of the asset pack version?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/asset_pack_version/' + value, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.message = { 'message': "Prototype asset pack version has been removed" }
                            this.download_prototype_details();
                        })
                        .catch((error) => {
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        },
        removeProjectPrototype(value) {
            this.$dialog
                .confirm("Are you sure about the delete of the project prototype?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/project_prototype/' + value, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.message = { 'message': "Project prototype has been removed" }
                            this.download_prototype_details();
                        })
                        .catch((error) => {
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        },
        uploadFile() {
            this.PrototypeResourceFile = this.$refs.prototype_file.files[0];
        },
        uploadAssetFile() {
            this.UploadingFile = true
            var formData = new FormData();
            formData.append('file', this.$refs.asset_pack_file.files[0]);
            this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/asset_pack_version', formData, { headers: Object.assign({}, this.$store.getters.authHeader, { 'Content-Type': 'multipart/form-data' }) }
            )
                .then((res) => {
                    this.message = { 'message': "Asset pack resource file has been uploaded" }
                    this.$refs.asset_pack_file.value = null;
                    this.download_prototype_details();
                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                }).finally(() => {
                    this.UploadingFile = false;
                });

        },
        uploadJSONFile() {
            this.JSONResourceFile = this.$refs.json_file.files[0];
        },
        uploadResourceFile() {
            this.RepositoryResourceFile = this.$refs.res_file.files[0];
        },
        upload_json_resource(project_prototype_uuid) {
            this.UploadingFile = true;
            var formData = new FormData();
            formData.append('file', this.JSONResourceFile);
            this.$http.post(this.$apiURL + '/admin/project_prototype/' + project_prototype_uuid, formData, {
                headers: Object.assign({}, this.$store.getters.authHeader, { 'Content-Type': 'multipart/form-data' })
            })
                .then((res) => {
                    this.message = { 'message': "JSON file has been uploaded" }
                    this.JSONResourceFile = null;
                    this.$refs.prototype_file.value = null;
                    this.download_prototype_details();

                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                })
                .finally(() => {
                    this.UploadingFile = false;
                });
        },
        upload_resource(version) {
            this.UploadingFile = true;
            var formData = new FormData();
            formData.append('file', this.PrototypeResourceFile);
            this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/version/' + version, formData, {
                headers: Object.assign({}, this.$store.getters.authHeader, { 'Content-Type': 'multipart/form-data' })
            })
                .then((res) => {
                    this.message = { 'message': "Resource file has been uploaded" }
                    this.PrototypeResourceFile = null;
                    this.$refs.res_file.value = null;
                    this.download_prototype_details();

                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                })
                .finally(() => {
                    this.UploadingFile = false;
                });
        },
        upload_gitlab_resource() {
            this.UploadingFile = true;
            var formData = new FormData();
            formData.append('file', this.RepositoryResourceFile);
            this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + "/resource", formData, {
                headers: Object.assign({}, this.$store.getters.authHeader, { 'Content-Type': 'multipart/form-data' })
            })
                .then((res) => {
                    this.message = { 'message': "Gitlab resource file has been uploaded" }
                    this.RepositoryResourceFile = null;
                    this.$refs.res_file.value = null;
                    this.download_prototype_details();
                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                })
                .finally(() => {
                    this.UploadingFile = false;
                });
        },
        resetModal() {
            this.delete_gitlab_repo = false;
        },
        deletePrototype() {
            this.$http.delete(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader, data: { delete_gitlab_repo: this.delete_gitlab_repo } }
            )
                .then((res) => {
                    var msg = this.delete_gitlab_repo ? "Prototype and the gitlab repository has been removed!" : "Prototype has been removed!"
                    this.$router.push({ name: "list_of_prototypes", params: { message: msg } })
                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                });
        },
        async runPipeline() {
            if (this.prototype.asset_pack_versions.length > 0) {

                await this.refreshPipelineLogs();
                if (this.gitlabJobTasks.length > 0 && ["pending", "running"].includes(this.gitlabJobTasks[0].status)) {
                    this.message = {
                        "message": "There is already a job in the queue with " + this.gitlabJobTasks[0].status + " status.",
                        "type": "warning"
                    }
                }
                else {
                    this.$http.post(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/run_pipeline', {}, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.openPipelineModalAndLogs()
                        })
                        .catch((error) => {
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        })
                }
            }
            else {
                this.message = {
                    "message": "Before the pipeline run you must: \n - set an asset pack with zip resource \n - set asset pack version",
                    "type": "warning"
                }
            }
        },
        download_job_log(job_id) {
            this.$http.get(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/job/' + job_id + '/log', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.TaskLog = res.data.log
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        async openPipelineModalAndLogs() {
            await this.refreshPipelineLogs()
            this.latestJobIsRunning = ['pending', 'running'].includes(this.gitlabJobTasks[0].status)
            this.showModal = !this.showModal;
            if (this.showModal) {
                this.startPeriodicFunction();
            }
        },
        startPeriodicFunction() {
            this.intervalId = setInterval(this.refreshPipelineLogs, 5000); // Adjust the interval as per your requirement.
        },
        async refreshPipelineLogs() {
            await this.$http.get(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/logs', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.gitlabJobTasks = res.data
                    if (this.latestJobIsRunning && this.gitlabJobTasks[0].status == 'success') {
                        this.download_prototype_details();
                        this.latestJobIsRunning = false
                    }
                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                })
        },
        async copy() {
            navigator.clipboard.writeText(this.$gitlabURL + this.prototype.name);
            this.copyMessage = "Copied!"
        },
        remove_otf_asset(otf_asset_uuid) {
            this.$dialog
                .confirm("Are you sure about the delete of the OTF Asset?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/otf_asset', { headers: this.$store.getters.authHeader, data: { otf_asset_uuid: otf_asset_uuid } }
                    )
                        .then((res) => {
                            this.otfAsset = null
                            this.message = { 'message': "OTF Asset has been removed." }
                            this.download_prototype_details();
                        })
                        .catch((error) => {
                            this.message = {
                                'message': error.response.data,
                                'type': "danger"
                            }

                        });
                })
        },
        download_JSON(project_prototype_uuid) {
            this.$http.get(this.$apiURL + '/admin/project_prototype/' + project_prototype_uuid, { headers: this.$store.getters.authHeader })
                .then((response) => {
                    let blob = new Blob([JSON.stringify(response.data['layout'])], { type: 'application/json' }),
                        url = window.URL.createObjectURL(blob)
                    window.open(url)

                })
                .catch((error) => {
                    this.message = JSON.parse(error.request.response)
                    this.message.type = "danger"
                })
        },
        deleteSpace(space) {
            this.$dialog
                .confirm("Are you sure about the delete space called: " + space.name + "?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/space/' + space.uuid, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.message = { 'message': "Space has been removed!" }
                            this.download_prototype_details();
                        })
                        .catch((error) => {
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        },
        cancel_pipeline_job(job_id) {
            this.cancelingJob = true;
            this.$http.delete(this.$apiURL + '/admin/space_prototype/' + this.$route.params.uuid + '/job/' + job_id + '/log', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    console.log(res)
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                })
                .finally(() => {
                    this.cancelingJob = false;
                    this.refreshPipelineLogs()
                });
        },
        stopPeriodicFunction() {
            clearInterval(this.intervalId);
        },
        stopPeriodicFunctionLog() {
            clearInterval(this.intervalIdLog);
        },
        handleRowClicked(id) {
            this.showLogModal = !this.showLogModal;
            if (this.showLogModal) {
                this.startPeriodicFunctionLog(id);
            }
        },
        startPeriodicFunctionLog(log_id) {
            this.selectedJobId = log_id
            this.intervalIdLog = setInterval(() => { this.download_job_log(log_id) }, 2000); // Adjust the interval as per your requirement.
        },
    },
    created() {
        this.init();
    },
}
</script>
